import { Injectable } from '@angular/core';
import { StoreConfig } from '@datorama/akita';
import { AbstractFeatureEntityStore } from '@y42/feature';
import { VisualizationDashboardGitFactoryService } from './visualization-dashboard-git-factory.service';
import { VisualizationDashboardState } from './visualization-dashboard-state.model';

const initialState: VisualizationDashboardState = {
  loading: true,
  last_used: {},
  starred: {},
  active: null,
  ui: {},
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'visualization-dashboard', idKey: '$path' })
export class VisualizationDashboardStore extends AbstractFeatureEntityStore<VisualizationDashboardState> {
  constructor(protected readonly gitFactory: VisualizationDashboardGitFactoryService) {
    super({
      name: 'Visualization',
      initialState,
      gitFactory,
      parentFolders: ['dashboards'],
    });
  }
}
